import TestCard from './TestCard';
import NoItems from './NoItems';
import { checkCircleFill, lockPadDot, noTestData } from '../../../constants/icons';

export default function TestJourney({ sections = [], lectures = [], quiz = [] }) {
  const quizByLectureId = quiz.reduce((acc, item) => {
    if (!acc[item.aa_lecture_id]) acc[item.aa_lecture_id] = [];
    acc[item.aa_lecture_id].push(item);
    return acc;
  }, {});

  const testLectures = lectures.filter(lec => lec.type === '3' || lec.type === 3);
  const finalData = sections.map((section) => {
    const sectionLectures = testLectures.filter(lec => lec.section_id === section.id);

    const data = sectionLectures.flatMap((lecture) => {
      const testList = quizByLectureId[lecture.id] || [];

      return testList.map((test) => ({
        testStatus: test.aa_mark_scored ? 'completed' : 'not started',
        date: test.aa_attempted_date,
        title: lecture.lecture_name,
        questions: test.assessment_details?.a_questions,
        marksScored: test.aa_mark_scored || 0,
        totalMarks: test.assessment_details?.a_mark,
        duration: test.aa_duration,
        totalDuration: test.aa_total_duration,
        grade: test.aa_grade,
        lectureId: lecture.id,
        icon: test?.aa_mark_scored ? checkCircleFill : lockPadDot,
      }));
    });

    return {
      title: section.s_name ?? section.section_name,
      data,
    };
  }).filter(section => section.data.length > 0);

  return (
    <div className="mky__stu-course_test-wrapper">
      {finalData.length > 0 ? (
        finalData.map((section, index) => (
        <>
          <h2>{`Section ${index + 1} : ${section.title}`}</h2>
            <ul className="course_test-content_list">
              {section.data.map((test, idx) => (
                <li
                  key={idx}
                  className={`test-item ${test.testStatus === 'completed' ? 'completed' : 'notstarted'}`}
                >
                  <TestCard
                    testStatus={test.testStatus}
                    date={test.date}
                    title={test.title}
                    questions={test.questions}
                    marksScored={test.marksScored}
                    totalMarks={test.totalMarks}
                    duration={test.duration}
                    totalDuration={test.totalDuration}
                    grade={test.grade}
                    icon={test.icon}
                  />
                </li>
              ))}
            </ul>
        </>
        ))
      ) : (
        <div className="w-100">
          <h2>Test Journey</h2>
          <NoItems
            icon={noTestData}
            title="No Test Journey to show!"
            description="This course is all about learning for fun--no tests and no grades, just good vibes and knowledge!"
          />
        </div>
      )}
    </div>
  );
}
